import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import { User } from '../../../shared/models/User';
import { UserAccess } from '../../models/access';
import { BackOfficeUser } from '../../models/backOfficeUser';
import { CMSAssociationResult, CrmUser } from '../../models/installer';
import * as AdminActions from '../actions/admin';

export interface AdminState {
    installers: {
        list: User[];
        cmsAssociations: CrmUser[];
    };
    usersAccess: {
        list: UserAccess[];
    };
    selectedInstaller: CrmUser;
    currentUser: BackOfficeUser;
}

export const ADMIN_INITIAL_STATE: AdminState = {
    installers: {
        cmsAssociations: [],
        list: [],
    },
    selectedInstaller: null,
    usersAccess: {
        list: [],
    },
    currentUser: null,
};

export const removeSubjectFromList = <T>(list: Array<T>, subject: T) => {
    const i = list.indexOf(subject);
    return [...list.slice(0, i), ...list.slice(i + 1)];
};

export default createReducer(
    ADMIN_INITIAL_STATE,

    on(AdminActions.loadInstallersCmsAssociation, (state, { cmsAssociationResults }): AdminState => {
        const cmsAssociations = cmsAssociationResults
            .map((cmsAssoc: CMSAssociationResult) => cmsAssoc.usersBu)
            .reduce((acc, val) => {
                acc.push(...val);
                return acc;
            }, []);
        return {
            ...state,
            installers: { ...state.installers, cmsAssociations },
        };
    }),

    on(AdminActions.loadUserAccess, (state, { users: usersaccess }): AdminState => {
        let list = [];
        if (usersaccess) {
            list = usersaccess.map((u) => ({
                ...u,
                role: u.extra['technical_name'],
            }));
        }
        return {
            ...state,
            usersAccess: { ...state.usersAccess, list },
        };
    }),

    on(AdminActions.updateUserAccess, (state, { userAccess }): AdminState => {
        // FIXME type UpdateUserAccess and UserAccess do not map
        userAccess.role = (userAccess as UserAccess).extra['technical_name'];

        const useraccessList = [...state.usersAccess.list, userAccess as UserAccess];

        return {
            ...state,
            usersAccess: { ...state.usersAccess, list: useraccessList },
        };
    }),

    on(
        AdminActions.setSelectedInstaller,
        (state, { installer }): AdminState => ({
            ...state,
            selectedInstaller: installer,
        }),
    ),

    on(
        AdminActions.setCurrentBackOfficeUserInfo,
        (state, { user }): AdminState => ({
            ...state,
            currentUser: user,
        }),
    ),
);

export const getAdminState = createFeatureSelector<AdminState>('admin');
